import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PayerComponent } from './payer.component';

const routes: Routes = [{ path: '', component: PayerComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PayerRoutingModule { }


